const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/layout/IntlProvider.tsx';
import { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { IntlProvider as RawIntlProvider } from 'react-intl';
import { selLocale } from '../selectors/i18nSelectors';
import { DEFAULT_LOCALE, intlLanguagesMap } from '../utils/intlUtils';

interface Props {
    children: ReactNode;
}

export const IntlProvider = (props: Props) => {
    const locale = useSelector(selLocale);

    const intl = {
        locale,
        defaultLocale: DEFAULT_LOCALE,
        fallbackOnEmptyString: false, // empty strings in translations should be displayed as such
        messages:
            locale === DEFAULT_LOCALE
                ? intlLanguagesMap[DEFAULT_LOCALE]
                : { ...intlLanguagesMap[DEFAULT_LOCALE], ...intlLanguagesMap[locale] },
    };

    return <RawIntlProvider {...intl}>{props.children}</RawIntlProvider>;
};
